import { List } from "lodash";
import { MessageMedia } from "./message.model";
import { ReactionSummary } from "./post.model";
import { v4 as uuidv4 } from 'uuid';

export class CommentModel {
    _id?: any;
    uuid: string;
    revision: string;
    status: string;
    vrsn: string;
    create_date: Date;
    update_date: Date;
    commenter_property: CommenterProperty;
    reaction_summary: ReactionSummary;
    page_id: string;
    post_id: string;
    comment_id: string;
    in_reply_to?: string;
    message?: string;
    message_media?: List<MessageMedia>[];
    created_by?: string;
    updated_by?: string;

  constructor(post_Id?: string){
    this.uuid = uuidv4();
    this.revision = uuidv4();
    this.status = "ACTIVE";
    this.vrsn = "ailedger-v1"
    this.create_date = new Date();
    this.update_date = new Date();
    this.commenter_property = new CommenterProperty;
    this.reaction_summary = new ReactionSummary
    this.post_id = post_Id;
  }  
}

export class CommenterProperty{
    id: string;
    name: string;
}
